import { useCallback, useEffect, useState } from "react";
import { presalesApi } from "../api/presalesApi";

export function useLeadDetail(leadId) {
  const [lead, setLead] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!leadId) { setLead(null); return; }
    setLoading(true);
    setError(null);
    try {
      const data = await presalesApi.getLead(leadId);
      setLead(data);
    } catch (err) {
      setError(err.message || "Failed to load lead");
    } finally {
      setLoading(false);
    }
  }, [leadId]);

  useEffect(() => {
    load();
  }, [load]);

  return { lead, setLead, loading, error, mutate: load };
}
